import { pl as pl$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var pl = {
  language: 'pl',
  country: 'pl',
  name: 'Polski',
  embeddedLocale: merge(error, login),
  flags: ['PL'],
  dateFns: pl$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { pl as default };
